import { render, staticRenderFns } from "./mobile-aside.vue?vue&type=template&id=0f254277&"
import script from "./mobile-aside.vue?vue&type=script&lang=js&"
export * from "./mobile-aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports